import { Dispatch, createListenerMiddleware } from '@reduxjs/toolkit';
import { initMergedDataDispatch } from 'store/utils/throttledDispatch';

import { reactionReceived_WS } from './actions';
import { resetReactionsState, setReactions } from './reactionsSlice';
import { ReceivedReaction } from './types';

import type { RootState } from 'store';

const REACTIONS_THROTTLE_TIMEOUT = 1000;

type ReactionHandlerType = ReturnType<typeof initMergedDataDispatch<string, { reaction: string }>>;
const reactionsHandlersMap = new Map<string, ReactionHandlerType>();

/**
 * Throttles reactions separately for each user and each reaction type
 * @param dispatch
 * @param receivedReaction
 */
const groupReactions = (dispatch: Dispatch, receivedReaction: ReceivedReaction) => {
  const { reaction } = receivedReaction;
  let reactionHandler = reactionsHandlersMap.get(reaction as string);
  if (!reactionHandler) {
    reactionHandler = initMergedDataDispatch<string, { reaction: string }>(
      (data, extras) => {
        dispatch(setReactions({ count: data.length, reaction: extras.reaction }));
      },
      { timeout: REACTIONS_THROTTLE_TIMEOUT }
    );
    reactionsHandlersMap.set(reaction as string, reactionHandler);
  }
  reactionHandler([reaction as string], { dispatch, reaction });
};

export const reactionsListener = createListenerMiddleware<RootState>();

reactionsListener.startListening({
  actionCreator: reactionReceived_WS,
  effect: ({ payload }, { dispatch }) => {
    groupReactions(dispatch, payload);
  },
});

reactionsListener.startListening({
  actionCreator: resetReactionsState,
  effect: () => {
    reactionsHandlersMap.clear();
  },
});
